import { c as _c } from "react/compiler-runtime";
import buildExperienceHref from '@/utils/routes/buildExperienceHref';
import { formatSlug } from '@winelidays/wld-tsx-2/utils';
import { lazy } from 'react';
const ExperienceCardContent = lazy(() => import('./ExperienceCardContent'));
const EntityCard = (t0) => {
    const $ = _c(13);
    let entity;
    let props;
    let t1;
    if ($[0] !== t0) {
        ({ entity, className: t1, ...props } = t0);
        $[0] = t0;
        $[1] = entity;
        $[2] = props;
        $[3] = t1;
    }
    else {
        entity = $[1];
        props = $[2];
        t1 = $[3];
    }
    const className = t1 === undefined ? "" : t1;
    let t2;
    if ($[4] !== entity.identifier) {
        t2 = buildExperienceHref(entity.identifier);
        $[4] = entity.identifier;
        $[5] = t2;
    }
    else {
        t2 = $[5];
    }
    const href = t2;
    const t3 = entity;
    let t4;
    if ($[6] !== href || $[7] !== props || $[8] !== t3) {
        t4 = <ExperienceCardContent experience={t3} href={href} {...props}/>;
        $[6] = href;
        $[7] = props;
        $[8] = t3;
        $[9] = t4;
    }
    else {
        t4 = $[9];
    }
    const cardContent = t4;
    const { mapPopup, vertical } = props;
    const cardClassName = `entity-card experience-${formatSlug(entity.typeActivity.name)} relative group w-full h-full flex flex-col ${mapPopup && vertical ? "w-81" : ""} ${className}`;
    let t5;
    if ($[10] !== cardClassName || $[11] !== cardContent) {
        t5 = <article className={cardClassName}>{cardContent}</article>;
        $[10] = cardClassName;
        $[11] = cardContent;
        $[12] = t5;
    }
    else {
        t5 = $[12];
    }
    return t5;
};
export default EntityCard;
